import { defineComponent as i, openBlock as t, createElementBlock as o, mergeProps as u, unref as e, renderSlot as m, createElementVNode as n, createCommentVNode as g } from "vue";
import { useScalarIcon as Z } from "../hooks/useScalarIcon.js";
const f = { key: 0 }, h = { key: 1 }, k = { key: 2 }, M = { key: 3 }, w = { key: 4 }, y = { key: 5 }, A = {
  name: "ScalarIconNotches"
}, H = /* @__PURE__ */ i({
  ...A,
  props: {
    label: {},
    weight: {}
  },
  setup(s) {
    const r = s, { bind: d, weight: a } = Z(r);
    return (p, l) => (t(), o("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      m(p.$slots, "default"),
      e(a) === "bold" ? (t(), o("g", f, l[0] || (l[0] = [
        n("path", { d: "M216.49,136.49l-80,80a12,12,0,1,1-17-17l80-80a12,12,0,1,1,17,17Zm-16-105a12,12,0,0,0-17,0l-152,152a12,12,0,0,0,17,17l152-152A12,12,0,0,0,200.49,31.51Z" }, null, -1)
      ]))) : e(a) === "duotone" ? (t(), o("g", h, l[1] || (l[1] = [
        n("path", {
          d: "M192,40V192H40Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M195.06,32.61a8,8,0,0,0-8.72,1.73l-152,152A8,8,0,0,0,40,200H192a8,8,0,0,0,8-8V40A8,8,0,0,0,195.06,32.61ZM184,184H59.31L184,59.31Z" }, null, -1)
      ]))) : e(a) === "fill" ? (t(), o("g", k, l[2] || (l[2] = [
        n("path", { d: "M200,40V192a8,8,0,0,1-8,8H40a8,8,0,0,1-5.66-13.66l152-152A8,8,0,0,1,200,40Z" }, null, -1)
      ]))) : e(a) === "light" ? (t(), o("g", M, l[3] || (l[3] = [
        n("path", { d: "M212.24,132.24l-80,80a6,6,0,1,1-8.48-8.48l80-80a6,6,0,1,1,8.48,8.48Zm-16-96.48a6,6,0,0,0-8.48,0l-152,152a6,6,0,1,0,8.48,8.48l152-152A6,6,0,0,0,196.24,35.76Z" }, null, -1)
      ]))) : e(a) === "regular" ? (t(), o("g", w, l[4] || (l[4] = [
        n("path", { d: "M213.66,133.66l-80,80a8,8,0,0,1-11.32-11.32l80-80a8,8,0,0,1,11.32,11.32Zm-16-99.32a8,8,0,0,0-11.32,0l-152,152a8,8,0,0,0,11.32,11.32l152-152A8,8,0,0,0,197.66,34.34Z" }, null, -1)
      ]))) : e(a) === "thin" ? (t(), o("g", y, l[5] || (l[5] = [
        n("path", { d: "M210.83,130.83l-80,80a4,4,0,1,1-5.66-5.66l80-80a4,4,0,1,1,5.66,5.66Zm-16-93.66a4,4,0,0,0-5.66,0l-152,152a4,4,0,0,0,5.66,5.66l152-152A4,4,0,0,0,194.83,37.17Z" }, null, -1)
      ]))) : g("", !0)
    ], 16));
  }
});
export {
  H as default
};
